export function state(initialState = {}) {
  return {
    publicMeta: initialState.publicMeta || undefined,
    routedModalAnimation: 'exited',
    accountType: '', // facilitator, admin, buyer
  };
}
